import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { normalizeInputNumber } from '../utils';

import { CHECKBOX, STYLED_NUMBER } from '../../Forms/fieldTypes';

const VMSFormComponent = ({
  onSubmit,
  showModal,
  formState = {},
  shouldDisplayCopyToAll,
  ...rest
}) => {
  const formData = [
    {
      keyName: 'residentCanSendKey',
      label: 'Residents can send digital keys',
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      label: '',
      textBefore: 'A resident can send',
      textAfter: 'digital key(s)',
      keyName: 'residentMaxSentKeys',
      fieldType: STYLED_NUMBER,
      validate: [],
      normalize: (value) => normalizeInputNumber(value, 0, 30),
      parse: (value) => Number(value),
      pattern: '[0-9]+',
      disabled: !formState?.residentCanSendKey,
    },
    {
      keyName: 'residentValidUntilLimitEnabled',
      label: `Residents 'Valid Until' limit enabled`,
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      label: '',
      textBefore: `Residents 'Valid Until' limit is`,
      textAfter: 'day(s)',
      keyName: 'residentValidUntilLimitDays',
      fieldType: STYLED_NUMBER,
      validate: [],
      normalize: (value) => normalizeInputNumber(value, 1, 30),
      parse: (value) => Number(value),
      pattern: '[0-9]+',
      disabled: !formState?.residentValidUntilLimitEnabled,
    },
    {
      keyName: 'residentsVisitorsTimeframeLimit',
      label: `Residents visitors timeframe limit`,
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
    {
      label: '',
      textBefore: `A staff member can send`,
      textAfter: 'digital key(s)',
      keyName: 'staffMaxSentKeys',
      fieldType: STYLED_NUMBER,
      validate: [],
      normalize: (value) => (value < 0 ? 0 : value),
      parse: (value) => Number(value),
      pattern: '[0-9]+',
    },
    {
      keyName: 'pmShouldApproveResidentKey',
      label: `Require approval for all resident-generated digital keys`,
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
    {
      keyName: 'visitorPhotoRequired',
      label: `Require upload of a photo ID for visitors`,
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      keyName: 'createCameraSnapshotOnVisitor',
      label: `Create camera snapshot on visitor entry`,
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      keyName: 'notifyPM',
      label: `Notify PM when resident adds a digital key`,
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
  ];
  return (
    <>
      <Box mb={3}>
        <GenericFormContainer
          formData={formData}
          formState={formState}
          onSubmit={onSubmit}
          submitText="Update Settings"
          backButton={false}
          isFullWidthForm
          {...rest}
        />
      </Box>

      {shouldDisplayCopyToAll && (
        <>
          <Button
            type="button"
            variant="contained"
            disableElevation
            onClick={() => showModal()}
          >
            Copy these settings to all buildings
          </Button>
          <Box py={2}>
            <Typography
              sx={(theme) => ({
                color: theme.palette.custom.settings.warning,
              })}
            >
              You may still change individual building settings, but this will
              overwrite any individual building settings previously made.
            </Typography>
          </Box>
        </>
      )}
    </>
  );
};

VMSFormComponent.propTypes = {
  onSubmit: PropTypes.func,
  showModal: PropTypes.func,
  formState: PropTypes.instanceOf(Object),
  shouldDisplayCopyToAll: PropTypes.bool,
};

export default VMSFormComponent;
